import React from 'react';
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField/TextField";

import './RegisterNewUser.css';

class RegisterNewUser extends React.Component {
    constructor(props) {
        super(props);

        this._handleTextFieldChange = this._handleTextFieldChange.bind(this);
    }

    render() {
        // email: {user.email}, id: {user.id}
        let user = this.props.newUser;

        return (
            <div>
                <h3>Welcome!</h3>
                <p>Please complete your registration.</p>
                <div>
                    <span className="name-label">Name:</span>
                    <TextField id='name'
                               className='name-edit'
                               onChange={this._handleTextFieldChange}
                               autoFocus={true}
                               placeholder="Your first name or nick name"
                    />
                </div>
                <div className="buttons">
                    <Button onClick={() => this.props.onSave({
                        ...user, name: this.state.name,
                    })}>
                        Submit
                    </Button>
                </div>
            </div>
        );
    }

    _handleTextFieldChange(e) {
        var newState = {};
        newState[e.target.id] = e.target.value;
        this.setState(newState);
    }
}

export default RegisterNewUser;
